/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserSignatureDto } from '../../models/user-signature-dto';

export interface UploadMySignature$Params {
      body?: {
'file': Blob;
}
}

export function uploadMySignature(http: HttpClient, rootUrl: string, params?: UploadMySignature$Params, context?: HttpContext): Observable<StrictHttpResponse<UserSignatureDto>> {
  const rb = new RequestBuilder(rootUrl, uploadMySignature.PATH, 'put');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserSignatureDto>;
    })
  );
}

uploadMySignature.PATH = '/users/me/signature';
